export default "__VITE_ASSET__BTb7Cic1__"